var React = require('react');

function RssFeed (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#F58634","d":"M8.682 26.667a2.907 2.907 0 100-5.813 2.907 2.907 0 000 5.813z","key":0}),React.createElement("path",{"fill":"#F58634","d":"M5.775 5.92v3.773c9.374 0 16.974 7.6 16.974 16.974h3.773c0-11.454-9.293-20.747-20.747-20.747zm0 7.547v3.773c5.2 0 9.427 4.227 9.427 9.427h3.773c0-7.294-5.906-13.2-13.2-13.2z","key":1})]);
}

RssFeed.defaultProps = {"fill":"none","viewBox":"0 0 33 32"};

module.exports = RssFeed;

RssFeed.default = RssFeed;
